<template>
  <b-row>
    <b-col
      md="12"
    >
      <!-- <div class="set-p d-none">
        <b-row class="match-height">
          <b-col
            lg="4"
            md="12"
            sm="12"
          >
            <b-card
              no-body
              text-variant="white"
              class="bg1-color"
            >
              <b-card-body
                class="d-flex justify-content-between align-items-center py-0"
              >
                <div class="truncate">
                  <h2 class="mb-25 font-weight-bolder text-white">
                    IDR {{ formatPrice(totalTopup) }}
                  </h2>
                  <span>Top Up</span>
                </div>
                <b-avatar
                  variant="light-secondary"
                  size="75"
                >
                  <svg
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                  >
                    <path
                      d="M20.668 0C31.714 0 40.668 8.954 40.668 20C40.668 31.046 31.714 40 20.668 40C9.62197 40 0.667969 31.046 0.667969 20C0.667969 8.954 9.62197 0 20.668 0ZM20.668 3C16.1593 3 11.8353 4.79107 8.64715 7.97919C5.45904 11.1673 3.66797 15.4913 3.66797 20C3.66797 24.5087 5.45904 28.8327 8.64715 32.0208C11.8353 35.2089 16.1593 37 20.668 37C25.1766 37 29.5007 35.2089 32.6888 32.0208C35.8769 28.8327 37.668 24.5087 37.668 20C37.668 15.4913 35.8769 11.1673 32.6888 7.97919C29.5007 4.79107 25.1766 3 20.668 3ZM20.668 10C21.0658 10 21.4473 10.158 21.7286 10.4393C22.0099 10.7206 22.168 11.1022 22.168 11.5V18.5H29.168C29.5658 18.5 29.9473 18.658 30.2286 18.9393C30.5099 19.2206 30.668 19.6022 30.668 20C30.668 20.3978 30.5099 20.7794 30.2286 21.0607C29.9473 21.342 29.5658 21.5 29.168 21.5H22.168V28.5C22.168 28.8978 22.0099 29.2794 21.7286 29.5607C21.4473 29.842 21.0658 30 20.668 30C20.2701 30 19.8886 29.842 19.6073 29.5607C19.326 29.2794 19.168 28.8978 19.168 28.5V21.5H12.168C11.7701 21.5 11.3886 21.342 11.1073 21.0607C10.826 20.7794 10.668 20.3978 10.668 20C10.668 19.6022 10.826 19.2206 11.1073 18.9393C11.3886 18.658 11.7701 18.5 12.168 18.5H19.168V11.5C19.168 11.1022 19.326 10.7206 19.6073 10.4393C19.8886 10.158 20.2701 10 20.668 10Z"
                      fill="black"
                      fill-opacity="0.15"
                    />
                  </svg>
                </b-avatar>
              </b-card-body>
              <b-card-footer class="text-center py-1 ds">
                <span>Total Top Up</span>
              </b-card-footer>
            </b-card>
          </b-col>
          <b-col
            lg="4"
            md="12"
            sm="12"
          >
            <b-card
              no-body
              text-variant="white"
              class="bg2-color"
            >
              <b-card-body
                class="d-flex justify-content-between align-items-center py-0"
              >
                <div class="truncate">
                  <h2 class="mb-25 font-weight-bolder text-white">
                    IDR {{ formatPrice(totalUsage) }}
                  </h2>
                  <span>Usage</span>
                </div>
                <b-avatar
                  variant="light-secondary"
                  size="75"
                >
                  <svg
                    width="34"
                    height="35"
                    viewBox="0 0 34 35"
                    fill="none"
                  >
                    <path
                      d="M18.6654 0.875V5.925C24.3154 6.74167 28.6654 11.575 28.6654 17.4583C28.6654 18.9583 28.3654 20.375 27.8654 21.6917L32.1987 24.2417C33.132 22.175 33.6654 19.875 33.6654 17.4583C33.6654 8.825 27.082 1.70833 18.6654 0.875ZM16.9987 29.125C10.5487 29.125 5.33203 23.9083 5.33203 17.4583C5.33203 11.575 9.68203 6.74167 15.332 5.925V0.875C6.8987 1.70833 0.332031 8.80833 0.332031 17.4583C0.332031 26.6583 7.78203 34.125 16.982 34.125C22.4987 34.125 27.382 31.4417 30.4154 27.3083L26.082 24.7583C24.9947 26.1234 23.6131 27.2252 22.0402 27.9813C20.4673 28.7375 18.7439 29.1284 16.9987 29.125Z"
                      fill="black"
                      fill-opacity="0.15"
                    />
                  </svg>
                </b-avatar>
              </b-card-body>
              <b-card-footer class="text-center py-1 ds">
                <span>Total Usage</span>
              </b-card-footer>
            </b-card>
          </b-col>
          <b-col
            lg="4"
            md="12"
            sm="12"
          >
            <b-card
              no-body
              text-variant="white"
              class="bg3-color"
            >
              <b-card-body
                class="d-flex justify-content-between align-items-center py-0"
              >
                <div class="truncate">
                  <h2 class="mb-25 font-weight-bolder text-white">
                    IDR {{ formatPrice(totalRemaining) }}
                  </h2>
                  <span>Remaining Budget</span>
                </div>
                <b-avatar
                  variant="light-secondary"
                  size="75"
                >
                  <svg
                    width="37"
                    height="27"
                    viewBox="0 0 37 27"
                    fill="none"
                  >
                    <path
                      d="M1.66797 5.16634C1.66797 4.28229 2.01916 3.43444 2.64428 2.80932C3.2694 2.1842 4.11725 1.83301 5.0013 1.83301H31.668C32.552 1.83301 33.3999 2.1842 34.025 2.80932C34.6501 3.43444 35.0013 4.28229 35.0013 5.16634V21.833C35.0013 22.7171 34.6501 23.5649 34.025 24.19C33.3999 24.8152 32.552 25.1663 31.668 25.1663H5.0013C4.11725 25.1663 3.2694 24.8152 2.64428 24.19C2.01916 23.5649 1.66797 22.7171 1.66797 21.833V5.16634Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-opacity="0.15"
                    />
                    <path
                      d="M18.3359 18.5C21.0974 18.5 23.3359 16.2614 23.3359 13.5C23.3359 10.7386 21.0974 8.5 18.3359 8.5C15.5745 8.5 13.3359 10.7386 13.3359 13.5C13.3359 16.2614 15.5745 18.5 18.3359 18.5Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-opacity="0.15"
                    />
                    <path
                      d="M1.66797 8.49967C3.43608 8.49967 5.13177 7.7973 6.38201 6.54705C7.63226 5.29681 8.33464 3.60112 8.33464 1.83301"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-opacity="0.15"
                    />
                    <path
                      d="M28.3359 25.1667C28.3359 23.3986 29.0383 21.7029 30.2886 20.4526C31.5388 19.2024 33.2345 18.5 35.0026 18.5"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-opacity="0.15"
                    />
                  </svg>

                </b-avatar>
              </b-card-body>
              <b-card-footer class="text-center py-1 ds">
                <span>Total Remaining Budget</span>
              </b-card-footer>
            </b-card>
          </b-col>
        </b-row>
      </div> -->
    </b-col>
    <b-col cols="12">
      <b-card class="invoiceForm">
        <!-- <b-card-body> -->
        <checkbox-table
          :data-table="dataInvoiceItem"
          :field-table="dataInvoiceField"
          :status="dataInvoiceStatus"
          :table-for="table"
          :data-for="dataList"
          :filter-date="filterDate"
          :mutation-for="mutationFor"
          :list="list"
          :action="false"
        >
          <template #head(checkbox)="data">
            <b-form-checkbox
              :key="data.id"
              v-model="checkAll"
              @input="selectAll"
            />
          </template>
          <template
            #cell(company_name)="data"
          >
            {{ data.value }}
          </template>
          <template
            #cell(invoice_date)="data"
          >
            {{ formatDateIdr(data.value) }}
          </template>
          <template
            #cell(due_date)="data"
          >
            {{ formatDateIdr(data.value) }}
          </template>
          <template #cell(total)="data">
            IDR {{ formatPrice(data.value) }}
          </template>
          <template
            #cell(actions)="data"
          >
            <b-button
              variant="outline-primary"
              size="sm"
              @click="viewDetail(data.item.invoice_number)"
            >
              <span class="align-middle">View</span>
            </b-button>
          </template>
        </checkbox-table>
      <!-- </b-card-body> -->
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  // BCardBody,
  // BCardFooter,
  BButton,
  // BAvatar,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import CheckboxTable from '@/views/component/DataTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    // BCardBody,
    // BCardFooter,
    BButton,
    CheckboxTable,
    // BAvatar,
  },
  data() {
    return {
      table: 'finance',
      dataList: 'dataInvoice',
      list: 'getDataList',
      filterDate: true,
      mutationFor: 'INVOICE',
      totalTopup: 0,
      totalUsage: 0,
      totalRemaining: 0,
    }
  },
  computed: {
    ...mapGetters('finance', {
      dataInvoiceField: 'getInvoiceField',
      dataInvoiceItem: 'getInvoiceItem',
      dataInvoiceStatus: 'getInvoiceStatus',
      totalBalance: 'getTotalBalance',
    }),
  },
  mounted() {
    this.clearTable()
    this.getDataList()
    this.dataTotalBalance().then(() => {
      this.totalTopup = this.totalBalance.total_topup
      this.totalUsage = this.totalBalance.total_usage
      this.totalRemaining = this.totalBalance.remain_balance
    })
  },
  methods: {
    ...mapActions('finance', [
      'getDataList',
      'detailInvoice',
      'clearTable',
      'dataTotalBalance',
    ]),
    formatDateIdr(date) {
      let dd = date.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    // formatCurrencyIdr(curr) {
    //   let newCurr = curr.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
    //   return newCurr.slice(0, -3)
    // },
    formatPrice(value) {
      if (value === null || typeof value === 'undefined') {
        return 0
      }
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    viewDetail(id) {
      this.detailInvoice(id).then(() => {
        this.$router.push({ path: `/invoice/view/${id}` })
      })
    },
  },
}
</script>
<style scoped>
* {
  font-family: 'Rubik';
}
</style>
